import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ConfirmEmailChange() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [state, setState] = useState({ loading: true, ok: false, message: '' });

  useEffect(() => {
    if (!token) {
      setState({ loading: false, ok: false, message: 'Missing confirmation token.' });
      return;
    }
    (async () => {
      try {
        const r = await fetch(`${API_URL}/api/auth/confirm-email-change`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });
        const data = await r.json().catch(() => ({}));
        if (!r.ok) {
          setState({ loading: false, ok: false, message: typeof data.detail === 'string' ? data.detail : 'Confirmation failed.' });
        } else {
          setState({ loading: false, ok: true, message: data.message || 'Email updated successfully.' });
        }
      } catch (e) {
        setState({ loading: false, ok: false, message: 'Network error. Please try again.' });
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-emerald-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md shadow-xl border-0" data-testid="confirm-email-change-card">
        <CardContent className="p-8 text-center">
          {state.loading ? (
            <>
              <Loader2 className="w-12 h-12 mx-auto mb-3 animate-spin text-indigo-500" />
              <p className="text-slate-700">Updating your email…</p>
            </>
          ) : state.ok ? (
            <>
              <CheckCircle2 className="w-12 h-12 mx-auto mb-3 text-emerald-500" />
              <h2 className="text-xl font-semibold mb-2">Email Updated</h2>
              <p className="text-sm text-slate-600 mb-4">{state.message}</p>
              <Link to="/login"><Button className="rounded-full">Sign in with new email</Button></Link>
            </>
          ) : (
            <>
              <XCircle className="w-12 h-12 mx-auto mb-3 text-red-500" />
              <h2 className="text-xl font-semibold mb-2">Email change failed</h2>
              <p className="text-sm text-slate-600 mb-4">{state.message}</p>
              <Link to="/login"><Button variant="outline" className="rounded-full">Back to Login</Button></Link>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
